import { next_app } from "../constant";

const SYNC_KEYS = [
  "auth_token",
  "is_login",
  "first_name",
  "last_name",
  "role",
  "verified",
  "reviews_addresses_id",
  "searchedAddress"
];

export const getSyncUrl = (targetUrl = next_app) => {
  const data = {};
  
  SYNC_KEYS.forEach(key => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      data[key] = value;
    }
  });

  if (Object.keys(data).length === 0) return targetUrl;

  try {
    // Robust Base64 encoding for Unicode
    const jsonString = JSON.stringify(data);
    const serializedData = btoa(encodeURIComponent(jsonString).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
    }));
    
    // Ensure we don't have trailing slashes mess up the query param if we join paths later
    const url = new URL(targetUrl);
    url.searchParams.set("sd", serializedData);
    return url.toString();
  } catch (e) {
    console.error("Error creating sync URL", e);
    return targetUrl;
  }
};

export const navigateToNextWithSync = (path = "/") => {
  const baseUrl = next_app.endsWith("/") ? next_app.slice(0, -1) : next_app;
  const targetUrl = `${baseUrl}${path}`;
  window.location.href = getSyncUrl(targetUrl);
};

export const getLogoutUrl = (targetUrl = next_app) => {
  try {
    const data = { action: 'logout' };
    const jsonString = JSON.stringify(data);
    const serializedData = btoa(encodeURIComponent(jsonString).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
    }));
    
    const url = new URL(targetUrl);
    url.searchParams.set("sd", serializedData);
    return url.toString();
  } catch (e) {
    console.error("Error creating logout URL", e);
    return targetUrl;
  }
};
